import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { StringCustomFieldConfig, SharedModule, FormInputComponent } from '@vendure/admin-ui/core';

@Component({
    template: `
        <div class="form-grid">
            <input
                class="form-control"
                type="date"
                [value]="date"
                (input)="onDateChange($event)"
                [min]="minDate"
                [readonly]="readonly"
            />
            <input
                class="form-control"
                type="time"
                [value]="time"
                (input)="onTimeChange($event)"
                [readonly]="readonly"
            />
        </div>
    `,
    standalone: true,
    imports: [SharedModule],
})
export class DatetimeFormFieldComponent implements FormInputComponent<StringCustomFieldConfig> {
    readonly: boolean;
    config: StringCustomFieldConfig;
    formControl: FormControl;

    minDate: string;
    date: string;
    time: string;

    ngOnInit() {
        const today = new Date();
        this.minDate = today.toISOString().split('T')[0];

        if (this.formControl.value) {
            const localDate = new Date(this.formControl.value); // parsed in local time
            this.date = localDate.toISOString().split('T')[0];
            this.time = localDate.toTimeString().slice(0, 5); // HH:mm
        }
    }

    onDateChange(event: Event) {
        this.date = (event.target as HTMLInputElement).value;
        this.updateFormControl();
    }

    onTimeChange(event: Event) {
        this.time = (event.target as HTMLInputElement).value;
        this.updateFormControl();
    }

    private updateFormControl() {
        if (this.date && this.time) {
            // Construct local Date object
            const localDateTime = new Date(`${this.date}T${this.time}`);
            // Save as ISO string in local time (no Z)
            this.formControl.setValue(localDateTime.toISOString());
            this.formControl.markAsDirty();
            this.formControl.markAsTouched();
        }
    }
}
